import { DropdownMenuTrigger } from "components/ui/dropdown_menu";
import { CompanyUserCombobox } from "components/ui/form_components/CompanyUserCombobox";

type BidResponseUserBulkUpdateButtonProps = {
  label: string;
  loading?: boolean;
  onClick: (userId: string | null) => void;
};

export function BidResponseUserBulkUpdateButton({
  label,
  loading,
  onClick,
}: BidResponseUserBulkUpdateButtonProps) {
  return (
    <CompanyUserCombobox
      value={undefined}
      onChange={(userId) => onClick(userId)}
      trigger={
        <DropdownMenuTrigger icon="user01" buttonType="primary" loading={loading} hideArrow>
          {label}
        </DropdownMenuTrigger>
      }
    />
  );
}
